module.exports = __webpack_public_path__ + "media/images/logo/auchan-1fa5f3c976c49c0bc1a6a04770a58ce5.png";